module.exports = __webpack_public_path__ + "static/media/9DESA36.68f650a2.jpg";